import script from "./PartnersFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersFooter.vue?vue&type=script&setup=true&lang=js"

import "./PartnersFooter.vue?vue&type=style&index=0&id=e20dadec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e20dadec"]])

export default __exports__